import { useContext, useEffect, useState } from "react";
import { Button, Col, Container, Form, Image, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import { authContext } from "../context/AuthContext";
import useCompanyType from "../hook/useCompanyType";
import LoadingList from "../loader/LoadingList";
import { isBase64 } from "../utils/isBase64";
import iconRecheck from '../img/icons/recheck.svg'
import ComponentModalEncuentaDoctor from "../components/conferencedoctor/ComponentModalEncuentaDoctor";
import Post from "../api/Post";
import { APPOINTMENT_UPDATE, GET_APPOINTMENT_BY_ID, SURVEY_ANSWER_SAVE, SURVEY_GET, TIPO_DOCUMENTO_PACIENTE_COLOMBIA } from "../api/Routes";
import ComponentModalErrorSever from "../components/ComponentModalErrorSever";
import Get from "../api/Get";
import { compareDate } from "../utils/compareDate";
import moment from "moment";
import StatusCita from "../components/conferencepublic/StatusCita";
import DoctorCitaConcluido from "../components/conferencedoctor/DoctorCitaConcluido";
import SimpleLoad from "../loader/SimpleLoad";
import DatePicker from 'react-datepicker'
import Put from "../api/Put";
import DoctorCitaNoComienza from "../components/conferencedoctor/DoctorCitaNoComienza";
import DoctorCitaNoComienzaDiferentDay from "../components/conferencedoctor/DoctorCitaNoComienzaDiferentDay";
import DoctorEnCitaOnDemand from "../components/conferencedoctor/DoctorEnCitaOnDemand";
import { setTimeAppointment } from "../utils/setTimeAppointment";
import ComponentModalPacienteMexico from "../components/conferencedoctor/ComponentModalPacienteMexico";
import { isConsultorio } from "../utils/isConsultorio";

function DoctorConferenceOndemand({ t }) {
    const { idParam } = useParams()
    const id = isBase64(idParam) ? atob(idParam) : null;
    const { auth } = useContext(authContext)
    const history = useHistory()
    const [estado, setEstado] = useState("loading")
    const [cita, setCita] = useState(null)
    const [textLoading, setTextLoading] = useState('Validando datos de la cita')
    const [codeServer, setCodeServer] = useState(null)
    const [textoStatusCita, setTextoStatusCita] = useState('')
    const companyType = useCompanyType()
    const [isSubmitingData, setIsSubmitingData] = useState(false)
    const [jitsi, setJitsi] = useState(null)
    const [showEncuesta, setShowEncuesta] = useState(false)
    const [question, setQuestion] = useState([])
    const [hangUp, setHangUp] = useState(false)
    const [startMet, setStartMet] = useState(false)
    const [messageCita, setMessageCita] = useState('')

    //edit data patient only colombia
    const [dateOfBirthday, setDateOfBirthday] = useState(null)
    const [dataEdit, setDataEdit] = useState(null)
    const [tipoDocumentoOpt, setTipoDocumentoOpt] = useState([])
    const [showDataEdit, setShowDataEdit] = useState(false)
    const handleCloseEditData = () => setShowDataEdit(false)
    //end edit data patient only colombia

    //handle error modal
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => setShowModalServer(false)
    const [errorServer, setErrorServer] = useState(null)
    //end handle error modal

    //handle success modal
    const [showSuccess, setShowSuccess] = useState(false)
    const handleCloseSuccess = () => setShowSuccess(false);
    //end handle success modal

    //modal paciente mexico
    const [showModalPaciente, setShowModalPaciente] = useState(false)
    const [dataPatient, setDataPatient] = useState(null)
    //end modal paciente mexico

    //btn consulta fallida
    const [showBtnConsultaFallida, setShowBtnConsultaFallida] = useState(false)
    const [isJoinedPatient, setIsJoinedPatient] = useState(false)

    //volver hacer peticion en historiaclinicia
    const [reload, setReload] = useState(true)

    //efecto para buscar la cita
    useEffect(() => {
        if (id) {
            Get({ url: `${GET_APPOINTMENT_BY_ID}/${id}`, access_token: auth.data.access_token })
                .then(respCita => {
                    //console.log(respCita)
                    let current_cita = respCita.data.data
                    setCita(current_cita)
                    let afterBefore = compareDate(current_cita.currentTime, current_cita.scheduleDTO.dateTimeEnd)
                    let fechaInit = compareDate(current_cita.currentTime, current_cita.scheduleDTO.dateTimeInit)
                    let sameDay = moment(current_cita.currentTime, "DD/MM/YYYY HH:mm:ss").format("DD-MM-YYYY") === moment(current_cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY")

                    //let startM = moment(current_cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss")
                    //let ServerTime =  moment(current_cita.currentTime, "DD/MM/YYYY HH:mm:ss")

                    if (current_cita.appointmentStatus === 'Pendiente') {
                        setTextoStatusCita('Su cita se encuentra pendiente de aprobación')
                        setEstado("statusCita")
                    }
                    else if (current_cita.appointmentStatus === 'Cancelada') {
                        setTextoStatusCita('Su cita ha sido cancelada.')
                        setEstado("statusCita")
                    }
                    else if (current_cita.appointmentStatus === "NoAtendida" ||
                        (afterBefore === "terminado" && current_cita.dataVideoCallList.length === 0 && current_cita?.scheduleDTO?.scheduleType?.id !== 'Consultorio')) {
                        setTextoStatusCita("Esta cita no ha sido atendida")
                        setEstado("statusCita")
                    }
                    else if (current_cita.appointmentStatus === "Fallida") {
                        setTextoStatusCita("Cita fallida")
                        setEstado("statusCita")
                    }
                    else if (current_cita.finished || afterBefore === "terminado") {

                        setMessageCita(t('cita_concluido'))
                        setEstado("citaConcluido")
                    }
                    else if (fechaInit === "noTerminado" && sameDay) {
                        //la cita aun no comienza
                        setMessageCita(t('cita_comenzara'))
                        setEstado("citaNoComienza")
                    }
                    else if (fechaInit === "noTerminado" && !sameDay) {
                        //la cita aun no comienza
                        setMessageCita(t('cita_no_comenzado'))
                        setEstado("citaNoComienzaDiferentDay")
                    } else {
                        setEstado("enCita")
                    }
                })
                .catch(error => {
                    //console.log(error)
                    //setShowModalServer(true)
                    setShowModalServer(true)
                    if (error.response) {
                        setErrorServer(error.response)
                        setCodeServer(error.response.data.status)
                    }
                    setEstado("errorComunication")
                })


            //Get encuesta de satisfacción
            Get({ url: `${SURVEY_GET}/doctor`, access_token: auth.data.access_token })
                .then(resp => {
                    const data = resp.data.data.response
                    setQuestion(data)
                })
                .catch(error => {
                    setShowModalServer(true)
                    if (error.response) {
                        setErrorServer(error.response)
                    }
                })
        } else {
            setEstado("notFoundAppointment")
        }
    }, [])


    //effecto para cuando cualga la llamada
    useEffect(() => {
        if (hangUp) {
            console.log('colgo la llamada')
            setTimeAppointment(id, 'Doctor', false, cita.dataVideoCallList, auth)
            setHangUp(false)
        }
    }, [hangUp])

    //effecto para cuando empieza la llamada
    useEffect(() => {
        if (startMet) {
            setTimeAppointment(id, 'Doctor', true, cita.dataVideoCallList, auth)
            setStartMet(false)
        }
    }, [startMet])

    const onComplete = () => {
        setTimeout(() => {
            setHangUp(true)
            setMessageCita(t('cita_concluido'))
            setEstado("citaConcluido")
            setShowEncuesta(true)
        }, 1000)
    }

    const handleAPI = (JitsiMeetAPI) => {
        setJitsi(JitsiMeetAPI)

        if (!isConsultorio(auth.data.role)) {
            if (cita.patientDTO.account?.allowRecord) {
                JitsiMeetAPI.addEventListener("videoConferenceJoined", () => {
                    JitsiMeetAPI.executeCommand("startRecording", { mode: `file` })
                    setStartMet(true)
                })
            } else {
                JitsiMeetAPI.addEventListener("videoConferenceJoined", () => {
                    JitsiMeetAPI.executeCommand("stopRecording", 'file')
                    setStartMet(true)
                })
            }
        }



        JitsiMeetAPI.addEventListener("videoConferenceLeft", () => {
            console.log('left')
            setMessageCita(t('cita_concluido'))
            setEstado("citaConcluido")
            setShowEncuesta(true)
        })

        //colgar llamada
        JitsiMeetAPI.addEventListener("readyToClose", () => {
            console.log('colgar llamada')
            setHangUp(true)
        })

        JitsiMeetAPI.addEventListener("participantJoined", (e) => {
            console.log('------------------------participantJoined------------------------')
            setIsJoinedPatient(true)
        })

        if (companyType === 'colombia') {
            console.log('overwrite')
            JitsiMeetAPI.executeCommand("overwriteConfig", {
                toolbarButtons: ['chat', 'camera', 'microphone', 'recording', 'select-background', 'settings', 'toggle-camera', 'tileview', 'recording']
            })
        }
    }

    useEffect(() => {
        if (companyType === 'colombia') {
            if ((jitsi && showBtnConsultaFallida) || (jitsi && isJoinedPatient)) {
                jitsi.executeCommand("overwriteConfig", {
                    toolbarButtons: ['chat', 'camera', 'hangup', 'microphone', 'recording', 'select-background', 'settings', 'toggle-camera', 'tileview', 'recording']
                })
            }
        }


    }, [showBtnConsultaFallida, companyType, isJoinedPatient])

    const handleCloseEncuesta = () => {
        let d = {
            id: parseInt(id),
            surveys: []
        }
        //enviamos la encuesta vacia
        Post({ url: SURVEY_ANSWER_SAVE, data: d, access_token: auth.data.access_token, header: true })
            .then(response => {
                //console.log(response)
                setShowEncuesta(false)
                setShowSuccess(true)
                setTimeout(() => {
                    setShowSuccess(false)
                    history.replace("/admin")
                }, 2000);
            })
            .catch(error => {
                setShowModalServer(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
    };

    const handleShowEditData = () => {
        const { patientDTO } = cita
        let dEdit = {
            nombre: patientDTO.name,
            middleName: patientDTO.middleName ? patientDTO.middleName : '',
            seccondSurname: patientDTO.seccondSurname ? patientDTO.seccondSurname : '',
            apellidos: patientDTO.lastName,
            phone: patientDTO.phone,
            email: patientDTO.email,
            identityDocumentType: patientDTO.identityDocumentType,
            documentNumber: patientDTO.documentNumber,
            peso: cita.peso,
            talla: cita.talla,
            motivoConsulta: cita.motivoConsulta,
            dateOfBirthday: patientDTO.dateOfBirthday
        }
        setDateOfBirthday(dEdit.dateOfBirthday ? new Date(moment(dEdit.dateOfBirthday, 'DD-MM-YYYY')) : new Date())
        setDataEdit(dEdit)

        Get({ url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA, access_token: auth.data.access_token })
            .then(response => {
                setTipoDocumentoOpt(response.data)
            })
            .catch(error => {
                setShowModalServer(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
        setShowDataEdit(true)
    }

    const editDataEdit = (value, type) => {
        let d = Object.assign({}, dataEdit)
        if (type === "identityDocumentType") {
            let ide = tipoDocumentoOpt.filter(el => el.id === parseInt(value))[0]
            d.identityDocumentType = ide
        } else {
            d[type] = value
        }
        setDataEdit(d)
    }

    const handleSubmitUpdateData = e => {
        let apptoUpdate = {
            id: cita.id,
            peso: dataEdit.peso,
            talla: dataEdit.talla,
            motivoConsulta: dataEdit.motivoConsulta,
            patient: {
                id: cita.patientDTO.id,
                name: dataEdit.nombre,
                middleName: dataEdit.middleName,
                seccondSurname: dataEdit.seccondSurname,
                lastName: dataEdit.apellidos,
                phoneNumber: dataEdit.phone,
                email: dataEdit.email,
                identityDocumentType: dataEdit.identityDocumentType,
                documentNumber: dataEdit.documentNumber,
                dateOfBirthday: moment(dateOfBirthday).format('DD-MM-YYYY')
            }
        }
        //console.log(apptoUpdate)
        setIsSubmitingData(true)
        Put({ url: APPOINTMENT_UPDATE, data: apptoUpdate, access_token: auth.data.access_token, header: true })
            .then(response => {
                //console.log(response)
                setCita(prev => ({
                    ...prev,
                    age: response.data.age,
                    peso: response.data.peso,
                    talla: response.data.talla,
                    motivoConsulta: response.data.motivoConsulta,
                    patientDTO: response.data.patientDTO
                }))
                setIsSubmitingData(false)
                setShowDataEdit(false)
            })
            .catch(error => {
                setIsSubmitingData(false)
                setShowModalServer(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })


    }

    const handleShowEditDataMexico = () => {
        const { patientDTO } = cita
        //console.log(patientDTO)
        let dEdit = {
            id: patientDTO.id,
            name: patientDTO.name ?? '',
            middleName: patientDTO.middleName ?? '',
            seccondSurname: patientDTO.seccondSurname ?? '',
            lastName: patientDTO.lastName ?? '',
            gender: patientDTO.gender ?? '',
            dateOfBirthday: patientDTO.dateOfBirthday ?? '',
            maritalStatus: patientDTO.maritalStatus ?? '',
            nationality: patientDTO.nationality ?? '',
            phoneNumber: patientDTO.phone ?? '',
            email: patientDTO.email ?? '',
            country: patientDTO.country ?? '',
            religion: patientDTO.religionDTO ?? '',
            bloodType: patientDTO.bloodType ?? '',
            occupation: patientDTO.occupation ?? '',
            language: patientDTO.languageDTO ?? '',
            address: patientDTO.address ?? '',
            allergies: patientDTO.allergies ?? '',
            account: patientDTO.account ?? '',
            company: patientDTO.company ?? '',
            medicalHistory: patientDTO.medicalHistory ?? '',
            externalId: patientDTO.externalId ?? '',
            cp: patientDTO.cp ?? '',
            municipio: patientDTO.municipio ?? '',
            state: patientDTO.state ?? '',
            patientRelationship: patientDTO.patientRelationshipDTO ?? '',
            peso: cita.peso ?? '',
            talla: cita.talla ?? '',
            motivoConsulta: cita.motivoConsulta ?? '',
            curp: patientDTO.curp ?? '',
            derechohabiencia: patientDTO.derechohabiencia ?? '',
            programaSMyMG: patientDTO.programaSMyMG ?? '',
            primeraVezAnio: patientDTO.primeraVezAnio ?? '',
            primeraVezUnemeSaih: patientDTO.primeraVezUnemeSaih ?? '',
            tipoDificultad: patientDTO.tipoDificultad ?? '',
            gradoDificultad: patientDTO.gradoDificultad ?? '',
            origenDificultad: patientDTO.origenDificultad ?? '',
            seConsideraIndigena: patientDTO.seConsideraIndigena ?? '',
            seAutodenominaAfromexicano: patientDTO.seAutodenominaAfromexicano ?? '',
            migrante: patientDTO.migrante ?? '',
            idCita: cita.id
        }
        setDataPatient(dEdit)
        setShowModalPaciente(true)
    }
    const handleCloseModalPacienteMexico = () => {
        setShowModalPaciente(false)
    }

    const onCompleteTimeStart = () => {
        setEstado("enCita")
    }




    const estadosMap = {
        loading: <LoadingList texto={textLoading} />,
        statusCita: <StatusCita text={textoStatusCita} helpCenter={cita?.patientDTO?.account?.helpCenter} cita={cita} doctor={true} />,
        citaConcluido: <DoctorCitaConcluido messageCita={messageCita} cita={cita} companyType={companyType}
            handleShowEditData={handleShowEditData} handleShowEditDataMexico={handleShowEditDataMexico}
            setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}
            reload={reload} setReload={setReload} />,
        citaNoComienza: <DoctorCitaNoComienza messageCita={messageCita} cita={cita} noComienza={true}
            companyType={companyType} onCompleteTimeStart={onCompleteTimeStart}
            handleShowEditData={handleShowEditData} ondemand={true}
            setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}
        />,
        citaNoComienzaDiferentDay: <DoctorCitaNoComienzaDiferentDay messageCita={messageCita} cita={cita}
            companyType={companyType} noComienza={true}
            handleShowEditData={handleShowEditData} ondemand={true}
            setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}
        />,
        enCita: <DoctorEnCitaOnDemand cita={cita} setCita={setCita} onComplete={onComplete} handleAPI={handleAPI}
            companyType={companyType} setShowEncuesta={setShowEncuesta} noComienza={false}
            handleShowEditData={handleShowEditData} handleShowEditDataMexico={handleShowEditDataMexico}
            setShowSuccess={setShowSuccess} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer}
            showEncuesta={showEncuesta} showBtnConsultaFallida={showBtnConsultaFallida} setShowBtnConsultaFallida={setShowBtnConsultaFallida}
            isJoinedPatient={isJoinedPatient} reload={reload} setReload={setReload}
        />,
    }

    return (
        <div className="content mh-100vh">
            <Container fluid className="py-3">
                {
                    estadosMap[estado]
                }

                <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
                    <Modal.Body className="p-0">
                        <div className="text-center position-relative overflow-hidden h-100p">
                            <Image src={iconRecheck} fluid className="img-recheck" />
                            <h5 className="mb-0 text-app-success"> {t('solicitud_exitosa')} </h5>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={showDataEdit} onHide={handleCloseEditData} size="lg">
                    <Modal.Body className="overflow-hidden">
                        {isSubmitingData && <SimpleLoad />}
                        <h5>Actualizar información</h5>
                        <hr />
                        {
                            dataEdit &&
                            <Row>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label>Nombre</Form.Label>
                                        <Form.Control
                                            className="input-form text-uppercase"
                                            value={dataEdit.nombre ?? ""}
                                            onChange={e => editDataEdit(e.target.value.toUpperCase(), "nombre")}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label>Segundo nombre</Form.Label>
                                        <Form.Control
                                            className="input-form text-uppercase"
                                            value={dataEdit.middleName ?? ""}
                                            onChange={e => editDataEdit(e.target.value.toUpperCase(), "middleName")}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label>Primer apellido</Form.Label>
                                        <Form.Control
                                            className="input-form text-uppercase"
                                            value={dataEdit.apellidos ?? ""}
                                            onChange={e => editDataEdit(e.target.value.toUpperCase(), "apellidos")}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label>Segundo apellido</Form.Label>
                                        <Form.Control
                                            className="input-form text-uppercase"
                                            value={dataEdit.seccondSurname ?? ""}
                                            onChange={e => editDataEdit(e.target.value.toUpperCase(), "seccondSurname")}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label>Tipo documento</Form.Label>
                                        <Form.Control
                                            className="input-form"
                                            value={dataEdit.identityDocumentType?.id}
                                            as="select"
                                            onChange={e => editDataEdit(e.target.value, "identityDocumentType")}
                                        >
                                            {
                                                tipoDocumentoOpt.map((item, i) => (
                                                    <option key={i} value={item.id}>{`${item.code} - ${item.name}`}</option>
                                                ))
                                            }
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label>No. documento</Form.Label>
                                        <Form.Control
                                            className="input-form"
                                            value={dataEdit.documentNumber ?? ""}
                                            onChange={e => editDataEdit(e.target.value, "documentNumber")}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label>Correo electrónico</Form.Label>
                                        <Form.Control
                                            className="input-form"
                                            value={dataEdit.email ?? ""}
                                            onChange={e => editDataEdit(e.target.value, "email")}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label>Teléfono</Form.Label>
                                        <Form.Control
                                            className="input-form"
                                            value={dataEdit.phone ?? ""}
                                            onChange={e => editDataEdit(e.target.value, "phone")}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary d-block">{t("fecha_nacimiento")} <span className="text-danger">*</span></Form.Label>
                                        <DatePicker
                                            className={`form-control input-form w-100`}
                                            selected={dateOfBirthday}
                                            dateFormat="dd-MM-yyyy"
                                            maxDate={new Date()}
                                            onChange={date => setDateOfBirthday(date)} />
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label>Peso (Kg)</Form.Label>
                                        <Form.Control
                                            className="input-form"
                                            type="number"
                                            value={dataEdit.peso ?? ""}
                                            onChange={e => editDataEdit(e.target.value, "peso")}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="3">
                                    <Form.Group>
                                        <Form.Label>Talla (cm)</Form.Label>
                                        <Form.Control
                                            className="input-form"
                                            type="number"
                                            value={dataEdit.talla ?? ""}
                                            onChange={e => editDataEdit(e.target.value, "talla")}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col xs="12" md="12">
                                    <Form.Group>
                                        <Form.Label>Motivo consulta</Form.Label>
                                        <Form.Control
                                            className="input-form"
                                            value={dataEdit.motivoConsulta ?? ""}
                                            onChange={e => editDataEdit(e.target.value, "motivoConsulta")}
                                        />
                                    </Form.Group>
                                </Col>
                                <hr />
                                <Col xs="12" md="12" className="text-right">
                                    <Button variant="outline-secondary" size="sm" onClick={handleCloseEditData}>Cancelar</Button>{' '}
                                    <Button variant="outline-success" size="sm" onClick={handleSubmitUpdateData}>Actualizar</Button>
                                </Col>
                            </Row>
                        }
                    </Modal.Body>
                </Modal>
            </Container>

            <ComponentModalPacienteMexico
                showModal={showModalPaciente}
                handleClose={handleCloseModalPacienteMexico}
                data={dataPatient}
                setCita={setCita}
            />

            <ComponentModalEncuentaDoctor
                cita={cita}
                show={showEncuesta}
                setShowEncuesta={setShowEncuesta}
                setShowSuccess={setShowSuccess}
                handleClose={handleCloseEncuesta}
                question={question}
                setShowModalServer={setShowModalServer}
                setErrorServer={setErrorServer}
            />

            <ComponentModalErrorSever
                show={showModalServer}
                handleClose={handleCloseModalServer}
                error={errorServer}
            />
        </div>
    )
}

export default withTranslation()(DoctorConferenceOndemand)